import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useParams } from 'react-router-dom';

import { FreeTrialReportOverview } from './FreeTrialReportOverview';
import { FreeTrialDownloadForm } from './FreeTrialDownloadForm';

import { getFreeTrialDownloadReport } from '../../../actions/partnerActions';

import NavBar from '../../../components/NavBar';
import { Footer } from '../../../components/Footer/Footer';

export const FreeTrialReport = () => {
  const { partnerId, freeTrialId } = useParams();

  const dispatch = useDispatch();

  const { loading, freeTrialReport, hasDownloadedPdf, user } = useSelector(
    ({
      partnerReducer: { loading, freeTrialReport, hasDownloadedPdf },
      userReducer: { user },
    }) => ({
      loading,
      freeTrialReport,
      hasDownloadedPdf,
      user,
    }),
  );

  if (partnerId !== freeTrialReport?.financeLenderId) {
    // console.log('Here it is right now');
    // let's do a track here to track when this occurs
    // mixpanel.track('Mismatch financeLenderId', {
    //   partnerId,
    //   financeLenderId: freeTrialReport?.financeLenderId,
    // });
    // This may cause too many events for ones that are wrong
  }

  useEffect(() => {
    // Get The Free Trial Instance
    dispatch(getFreeTrialDownloadReport({ freeTrialId }));
  }, [partnerId, freeTrialId]);

  // What do we need for the free trial report?

  return (
    <div>
      <NavBar currentPath="/partner/:partnerId/free_trial/:freeTrialId" />
      <FreeTrialReportOverview loading={loading} freeTrialReport={freeTrialReport} />
      <FreeTrialDownloadForm
        loading={loading}
        freeTrialReport={freeTrialReport}
        hasDownloadedPdf={hasDownloadedPdf}
        user={user}
      />
      <Footer currentPath="/partner" />
    </div>
  );
};
